var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9.2,
    r: 1.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16c-2.2 2.2-5.7 2.1-7.9-.1S5.8 10.2 8 8c1.1-1.1 2.5-1.7 4-1.7s2.9.6 4 1.7c2.2 2.2 2.2 5.8 0 8zm.7-8.7c-1.9-1.9-4.8-2.5-7.3-1.5S5.3 9.3 5.3 12s1.6 5.2 4.1 6.2 5.4.5 7.3-1.5c1.3-1.3 2-3 2-4.7s-.7-3.5-2-4.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 10.9H13v4.2h-2.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgInfo;